const DEFAULT_MAX_SCHEDULED_TASKS = 3;
const EXTENDED_MAX_SCHEDULED_TASKS = 6;

export const getMaxScheduledTasks = (isTasksUpdate: boolean) =>
  isTasksUpdate ? EXTENDED_MAX_SCHEDULED_TASKS : DEFAULT_MAX_SCHEDULED_TASKS;

export const isAtActiveScheduleCap = (
  activeCount: number,
  isTasksUpdate: boolean
) => activeCount >= getMaxScheduledTasks(isTasksUpdate);
